import { FC } from 'react'
import { useEmployeeWithAppraisalInviteInfo } from '../../../graphql/employee/hooks/useEmployeeWithAppraisalInviteModalInfo'
import { DashboardAppraisalInviteModal } from './DasboardAppraisalInviteModal'

interface DashboardAppraisalInviteContainerProps {
  employeeId: string
  closeModal: () => void
}

export const DashboardAppraisalInviteModalContainer: FC<DashboardAppraisalInviteContainerProps> = ({ employeeId, closeModal }) => {
  const { data, error, loading } = useEmployeeWithAppraisalInviteInfo(employeeId)

  return (
    <DashboardAppraisalInviteModal
      loading={loading}
      queryError={error}
      employee={data?.employeeDisplayTinyInfoByEmployeeId}
      appraisalSeason={data?.appraisalSeasonOptionByEmployeeId}
      additionalParticipantOptions={data?.nonParticipantsOptionsForEmployee}
      meetingInviteOptions={data?.meetingInviteOptionsForEmployee}
      onCancel={closeModal}
    />
  )
}
